<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current='page'
      :disablePage='disablePage'
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
           <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>

                </div>
          <div class="queryItem">
            <label >销售单号:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.orderNo"></lk-input>
          </div>
          <div class="queryItem">
            <label >创建时间:</label>
            <timeStampDatePicker placeholder='请选择' class="item" v-model="query.createTime" type='daterange'></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label >订单状态:</label>
            <lk-select placeholder='请选择' class="item" v-model.trim='query.status'>
              <lk-option v-for="(item,index) in recipeStatusList" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label >处方时间:</label>
            <timeStampDatePicker placeholder='请选择' class="item" v-model.trim='query.prescriptionTime'  type='daterange'></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label >处方状态:</label>
            <lk-select v-model='query.prescriptionStatus' class="item" clearable  >
              <lk-option v-for="(item,index) in prescriptionStatusList" :key="index" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label >患者姓名:</label>
            <lk-input  placeholder='请输入' class="item" v-model.trim='query.patientName'></lk-input>
          </div>
          <div class="queryItem">
            <label >处方医院:</label>
            <lk-input  placeholder='请输入' class="item" v-model.trim='query.prescriptionHospital'></lk-input>
          </div>
              <div class="queryItem">
            <label>处方医生:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.prescriptionDoctor"></lk-input>
          </div>
          <div class="queryItem">
            <label >诊断说明:</label>
            <lk-select placeholder='请选择' class="item" v-model.trim='query.diseaseId'>
              <lk-option v-for="(item,index) in diseaseList" :key="index" :value='item.id'>{{item.diseaseName}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label >诊断补充说明:</label>
            <lk-input  placeholder='请输入' class="item" v-model.trim='query.diseaseRemark'></lk-input>
          </div>
          <div class="queryItem">
            <label >零售分类:</label>
            <lk-select placeholder='请选择' class="item" v-model.trim='query.retailType'>
              <lk-option v-for="(item,index) in publicParams.retailTypes" :key="index" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>采购来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable  >
              <lk-option v-for="(item,index) in publicParams.goodsOrigin" :key="index" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>订单来源:</label>
            <lk-select v-model='query.orderSourceType' class="item" clearable  @on-change='(val)=>{val===0&&(query.epCreatorType=null)}'>
              <lk-option v-for="(item,index) in sourceTypeList" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>处方来源:</label>
            <lk-select v-model='query.epCreatorType' :disabled="query.orderSourceType===0" class="item" clearable  >
              <lk-option :value='1'>医生开具</lk-option>
              <lk-option :value='2'>药师开具</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label >问诊医院:</label>
            <lk-input  placeholder='请输入' class="item" v-model.trim='query.inquiryHospital'></lk-input>
          </div>
          <div class="queryItem">
            <label >问诊医生:</label>
            <lk-input  placeholder='请输入' class="item" v-model.trim='query.inquiryDoctor'></lk-input>
          </div>
          <div class="queryItem">
            <label >联系人:</label>
            <Contact class="item" v-model="query.contact" :ifAble="true" @contactValue="contactValue"></Contact>
          </div>
          <div class="queryItem" v-if="this.$store.state.user.roleType !== 2">
            <label >门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIds"></storeListSelect>

          </div>
          <div class="queryItem">
            <label >提交人:</label>
            <lk-input  placeholder='请输入' class="item" v-model.trim='query.inputUserName'></lk-input>
          </div>
          <div class="queryItem">
            <label >最后修改人:</label>
            <lk-input  placeholder='请输入' class="item" v-model.trim='query.modifiedUserName'></lk-input>
          </div>
          <div class="queryItem">
            <label>联系人电话:</label>
            <lk-input v-model="query.contactPhone" class="item" clearable type="text" :maxlength='20'></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div>
          <DownloadButton class="mb16 mr8" @on-click="downloadExcel" v-if="handlePermission('prescriptionDownload')"></DownloadButton>
          <lk-button type='primary' :disabled="!selection || selection.length === 0" @click="batchPrintRecipePics" v-if="handlePermission('printPrescriptionPics')">打印处方图片</lk-button>
        </div>
        <lk-table border :columns="columns" :data="tableData" @on-selection-change='handleSeletion'/>
      </div>
    </QueryFrame>
    <!-- 处方批量打印start -->
    <section id="printArea" ref="print" class="print-area">
      <div class="recipe-img" v-for="(item, index) in recipes" :key="index">
        <img :src="decodeURIComponent(item)"/>
        <p class="page-break"></p>
      </div>
    </section>
    <!-- 处方批量打印end -->
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import timeStampDatePicker from '../../components/timeStampDatePicker.vue';
import DownloadButton from '../../components/download/DownloadButton.vue';
import utils from '../../libs/utils';
import sale from '../../services/sale';
import goods from '../../services/goods';
// import system from '@/services/system';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import Contact from '../../components/sale/Contact';
import sharedData from '../../libs/sharedDara';

export default {
  name: 'getPrescriptionOrder',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, timeStampDatePicker, DownloadButton, Contact,
  },
  data() {
    return {
      recipeStatusList: sharedData.orderStatus,
      usageList: [],
      disablePage: false,
      diseaseList: [],
      sourceTypeList: [],
      query: {
        orderNo: '',
        createTime: [],
        prescriptionTime: [],
        storeIds: [],
        purchaseType: 1,
      },
      prescriptionStatusList: [
        {
          value: 1,
          name: '未完成',
        },
        {
          value: 2,
          name: '已完成',
        },
      ],
      params: {
        orderNo: '',
        createTime: [],
        prescriptionTime: [],
        storeIds: [],
      },
      subColumns: [
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '药品通用名', key: 'approvedDrugNames', minWidth: 116 },
        { title: '商品数量', key: 'goodsCount', minWidth: 116 },
        { title: '用量', key: 'goodsDosage', minWidth: 116 },
        { title: '用法', key: 'goodsUsage', minWidth: 116 },
        { title: '开始用药时间', key: 'usageStartTime', minWidth: 116 },
        { title: '用药周期', key: 'medicationCycle', minWidth: 116 },
        { title: '用药提醒天数', key: 'rebuyRemindDays', minWidth: 116 },
      ],
      columns: [
        {
          type: 'expand',
          minWidth: 50,
          fixed: 'left',
          render: (h, params) => h('lk-table', {
            props: {

              columns: this.subColumns,
              data: params.row.subList,

            },
          }),
        },
        {
          title: '选择',
          minWidth: 60,
          fixed: 'left',
          type: 'selection',
        },
        { title: '订单来源', key: 'epSourceTypeName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        {
          title: '订单状态',
          key: 'saleOrderStatusName',
          minWidth: 116,
        },
        {
          title: '处方状态',
          key: 'saleOrderPrescriptionStatus',
          minWidth: 116,
          render: (h, params) => h('span', params.row.salePrescriptionStatus === 1 ? '未完成' : '已完成'),
        },
        { title: '销售单号', key: 'salePrescriptionOrderNo', minWidth: 116 },
        { title: '患者姓名', key: 'salePrescriptionPatientName', minWidth: 116 },
        { title: '处方医院', key: 'salePrescriptionPrescriptionHospital', minWidth: 116 },
        { title: '处方单号', key: 'salePrescriptionPrescriptionNo', minWidth: 130 },
        { title: '医院代码', key: 'salePrescriptionPrescriptionHospitalCode', minWidth: 116 },
        { title: '科室', key: 'salePrescriptionHospitalDept', minWidth: 116 },
        { title: '处方时间', key: 'salePrescriptionTime', minWidth: 116 }, //  wzy 缺少
        { title: '患者年龄', key: 'salePrescriptionPatientAge', minWidth: 116 },
        { title: '患者性别', key: 'salePrescriptionPatientGender', minWidth: 116 },
        { title: '证件类型', key: 'salePrescriptionPermissionTypeStr', minWidth: 116 },
        { title: '证件号码', key: 'salePrescriptionPatientIdCard', minWidth: 116 },
        { title: '患者联系方式', key: 'salePrescriptionPatientPhone', minWidth: 116 },
        { title: '诊断说明', key: 'salePrescriptionDiseaseName', minWidth: 116 },
        { title: '诊断补充说明', key: 'salePrescriptionAdditionalRemark', minWidth: 116 },
        { title: '处方医生', key: 'salePrescriptionPrescriptionDoctor', minWidth: 116 },
        { title: '调配人', key: 'salePrescriptionAllocaterName', minWidth: 116 },
        { title: '复核人', key: 'salePrescriptionReviewerName', minWidth: 116 },
        { title: '问诊医院', key: 'salePrescriptionInquiryHospital', minWidth: 116 },
        { title: '问诊医生', key: 'salePrescriptionInquiryDoctor', minWidth: 116 },
        { title: '联系人', key: 'salePrescriptionContact', minWidth: 116 },
        { title: '联系人电话', key: 'salePrescriptionContactPhone', minWidth: 116 },
        { title: '零售分类', key: 'goodsTypeName', minWidth: 116 },
        { title: '商品来源', key: 'saleOrderPurchaseTypeName', minWidth: 116 },
        { title: '数量', key: 'goodsNum', minWidth: 116 },
        { title: '药师', key: 'salePrescriptionCreateUserName', minWidth: 116 },
        { title: '提交人', key: 'inputUserName', minWidth: 116 },
        { title: '提交时间', key: 'inputTime', minWidth: 116 },
        { title: '最后修改人', key: 'modifiedUserName', minWidth: 116 },
        { title: '最后修改时间', key: 'modifiedTime', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            params.row.epSourceType ? this.handlePermission('viewRecipsSales') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'viewRecipsSales', params: { id: params.row.salePrescriptionId } });
                },
              },
            }, '查看') : null
            // 线下订单查看
            :  this.handlePermission('viewPharmaceuticalSales') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'viewPharmaceuticalSales', params: { id: params.row.salePrescriptionId } });
                },
              },
            }, '查看') : null,
            this.handlePermission('recipsSalesAdd') && params.row.salePrescriptionStatus === 1 ?
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.openBlank('recipsSalesAdd', { id: params.row.salePrescriptionId, orderId: params.row.salePrescriptionOrderId });
                },
              },
            }, '编辑') : null,

            this.handlePermission('recipeSalesEdit') && params.row.salePrescriptionStatus === 2 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.openBlank('recipeSalesEdit', { id: params.row.salePrescriptionId, orderId: params.row.salePrescriptionOrderId });
                },
              },
            }, '修改') : null,
            // h('lk-button', {
            //   props: {
            //     type: 'text',
            //     size: 'small',
            //   },
            //   on: {
            //     click: () => {
            //       this.roleDel(params.row.sysRoleId);
            //     },
            //   },
            // }, '删除'),
          ]),
        },
      ],
      tableData: [],
      selection: [],
      recipes: [],
      gender: ['未知', '男', '女'],
      prescriptionStatus: ['', '未录入', '已录入'],
    };
  },
  methods: {
    downloadExcel() {
      const params = utils.deepClone(this.params);

      delete params.page;
      delete params.size;
      if (params.createTime.length) {
        params.createTimeStart = params.createTime[0];
        params.createTimeEnd = params.createTime[1];
      }
      if (params.prescriptionTime.length) {
        params.prescriptionTimeStart = params.prescriptionTime[0];
        params.prescriptionTimeEnd = params.prescriptionTime[1];
      }
      delete params.createTime;
      delete params.prescriptionTime;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      sale.downloadlistOrderPrescription(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleSeletion(selection) {
      this.selection = selection;
    },
    batchPrintRecipePics() {
      this.recipes = [];
      const prescriptionIdList = this.selection.map(item => item.salePrescriptionId);
      sale.printPrescriptionPics({ prescriptionIdList }).then((res) => {
        if (res.data.status === 200) {
          if (!res.data.data || res.data.data.length === 0) {
            this.$Message.warning('所选处方无可打印图片');
            return;
          }
          this.recipes = res.data.data;
          this.$nextTick(() => {
            this.$print(this.$refs.print);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // getStoreList() {
    //   system.getBelongStores()
    //     .then((res) => {
    //       if (res.data.status === 200) {
    //         this.storeList = res.data.data;
    //       } else {
    //         this.$Message.error(res.data.error);
    //       }
    //     }).catch((err) => {
    //       utils.handleError(err);
    //     });
    // },
    getDiseaseList() {
      return new Promise((resolve, reject) => {
        sale.getDiseaseInfo().then((res) => {
          if (res.data.status === 200) {
            this.diseaseList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
            reject(res.data.error);
          }
        }).catch((err) => {
          reject(err);
          utils.handleError(err);
        });
      });
    },
    getListSourceType() {
      return new Promise((resolve, reject) => {
        sale.getListSourceType().then((res) => {
          if (res.data.status === 200) {
            this.sourceTypeList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
            reject(res.data.error);
          }
        }).catch((err) => {
          reject(err);
          utils.handleError(err);
        });
      });
    },
    getGoodsUsage() {
      return new Promise((resolve, reject) => {
        goods.getAllDictionary().then((res) => {
          if (res.data.status === 200) {
            this.usageList = res.data.data.filter(item => item.dictionaryType === 14);
          } else {
            this.$Message.error(res.data.error);
            reject(res.data.error);
          }
          resolve();
        }).catch((err) => {
          reject(err);
          utils.handleError(err);
        });
      });
    },
    clear() {
      this.query = {
        orderNo: '',
        createTime: [],
        prescriptionTime: [],
        storeIds: [],
        nameMix: '',
        purchaseType: null,
        inquiryDoctor: null,
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.params.createTimeStart = null;
      this.params.createTimeEnd = null;
      this.params.prescriptionTimeStart = null;
      this.params.prescriptionTimeEnd = null;
      if (this.params.createTime.length) {
        this.params.createTimeStart = this.params.createTime[0];
        this.params.createTimeEnd = this.params.createTime[1];
      }
      if (this.params.prescriptionTime.length) {
        this.params.prescriptionTimeStart = this.params.prescriptionTime[0];
        this.params.prescriptionTimeEnd = this.params.prescriptionTime[1];
      }
      const temp = utils.deepClone(this.params);
      delete temp.createTime;
      delete temp.prescriptionTime;
      // console.log(params);
      sale
        .listOrderPrescription(temp)
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            // console.log(res.data.data.count);
            // console.log(res.data.data.list)
            this.count = res.data.data.count;
            let number = 1;
            res.data.data.list.forEach((item) => {
              const result = {};
              utils.exchangeTable(item, result);
              result.goodsTypeName = utils.exchangePublicParams(item.salePrescription.retailType, this.publicParams.retailTypes);
              // console.log(result);
              result.number = number++;
              result.salePrescriptionPermissionTypeStr = this.$store.getters.getCredentialsTypeStr(result.salePrescriptionPermissionType);
              result.salePrescriptionPatientGender = this.gender[result.salePrescriptionPatientGender];
              result.loading = false;
              if (item.saleUsageList) {
                item.saleUsageList.forEach((el) => {
                  el.usageStartTime = utils.exchangeTime(el.usageStartTime);
                  el.goodsUsage = el.goodsUsage || utils.exchangeDictionary(this.usageList, el.goodsUsageType);
                  // el.goodsUsage
                });
              }
              result.epSourceType = item.saleOrder.epSourceType;// 订单类型
              result.pharmaceuticalStatus = item.saleOrder.pharmaceuticalStatus || '';// 是否在药学服务范围内，1是2否
              result.epSourceTypeName = item.saleOrder.epSourceTypeName;
              result.inputUserName = item.salePrescription.inputUserName;
              result.createTime = utils.exchangeTimeToSecond(item.salePrescription.createTime);
              if (item.salePrescription.inputTime) {
                result.inputTime = utils.formatTime(Number(item.salePrescription.inputTime));
              } else {
                result.inputTime = '';
              }
              if (item.salePrescription.prescriptionTime) {
                result.salePrescriptionTime = utils.formatDate(Number(item.salePrescription.prescriptionTime));
              } else {
                result.salePrescriptionTime = '';
              }
              if (item.salePrescription.modifiedTime) {
                result.modifiedTime = utils.exchangeTimeToSecond(Number(item.salePrescription.modifiedTime));
              } else {
                result.modifiedTime = '';
              }
              result.modifiedUserName = item.salePrescription.modifiedUserName;
              result.subList = item.saleUsageList
                ? utils.mergeSameDrugs(item.saleUsageList, 'goodsStoreId', 'goodsCount')
                : null;
              result._disableExpand = item.salePrescription.retailType === 3;
              this.tableData.push(result);
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    /**
     * @description: 查看、修改、编辑在新窗口打开
     * @param {*} name 路由名称
     * @param {*} params 路由参数
     * @return {*}
     */
    openBlank(name, params) {
      const routeData = this.$router.resolve({
        name,
        params,
      });
      window.open(routeData.href, '_blank');
    },
    contactValue(val) {
      this.query.contactPhone = val;
    },
  },
  mounted() {
    Promise.all([
      this.getGoodsUsage(),
      this.getDiseaseList(), this.getListSourceType(),
    ]).then(() => {
      this.handleSearch(true);
    }).catch((err) => {
      this.handleSearch(true);
      console.log(err);
    });
  },
};
</script>
<style lang="less" scoped>
@media print {
  .print-area {
    display: block;
  }
  .page-break {
    page-break-after: always;
  }
}
@media screen {
  .print-area {
    display: none;
  }
}
.recipe-img {
  display: flex;
  align-content: center;
  justify-content: center;
  img {
    max-height: 1000px;
  }
}
</style>
